import { Grid, Paper } from '@material-ui/core';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as shoppingCartActions from '~/store/legacy/actions/shoppingCartActions';
import * as userActions from '~/store/legacy/actions/userActions';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors';
import { SERVICE_TYPE } from '~/constant';
import * as userSelectors from '~/store/legacy/selector/userSelectors';
import PlaceOrderButton from './PlaceOrderButton';
import PromoCodeInput from './PromoCodeInput';
import useStyles from './ShoppingCart.style.js';
import PriceLines from './PriceLines.jsx';
import Tips from './tips/Tips.jsx';
import PriceLineTotal from './PriceLineTotal';

/**
 * Display of the cart itself on the checkout page and in the header, including
 * @param {object} props
 * @param {boolean} props.fullWidth
 * @param {boolean} props.outline
 * @param {'checkout'|'place_order'} props.variant - as a dropdown from the header
 */
const ShoppingCart = (props) => {
  const { variant } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(userSelectors.selectIsUserLoggedIn);
  const user = useSelector(userSelectors.selectUser);
  const serviceType = useSelector(shoppingCartSelectors.selectServiceType);
  const { address } = useSelector(userSelectors.selectUserAddress);
  const { time, timeLoaded, addressId: shoppingCartAddressId } = useSelector(
    shoppingCartSelectors.selectShoppingCartData
  );
  const meals = useSelector(shoppingCartSelectors.selectMeals);
  const isUserVerified = useSelector(userSelectors.selectIsUserVerifed);

  useEffect(() => {
    if (isUserLoggedIn && !timeLoaded) {
      dispatch(shoppingCartActions.getDeliveryTimes());
    }
  }, [variant]);

  useEffect(() => {
    // if no shoppingCart addressId means user
    // add to cart before selecting a saved address
    if (isUserLoggedIn && !shoppingCartAddressId) {
      if (address) {
        dispatch(userActions.setNewUserSearchAddress(address));
      }
    }
  }, [variant]);

  const checkoutTotal = async () => {
    if (
      isUserLoggedIn &&
      timeLoaded &&
      shoppingCartAddressId &&
      user.phone_number &&
      user.verified
    ) {
      await dispatch(shoppingCartActions.checkout());
    }
  };

  /**
   * This is the magic that updates the whole page every time any little bit changes.
   * It's extremely wild that it happens here instead of in redux actions.
   */
  useEffect(() => {
    checkoutTotal();
  }, [meals, isUserLoggedIn, timeLoaded, time, shoppingCartAddressId, isUserVerified]);

  return (
    <Paper elevation={0} className={classNames(classes.shoppingCart, classes.fullWidth)}>
      <Grid container spacing={3} className={classes.shoppingContainer}>
        <Grid item xs={12}>
          <PromoCodeInput />
        </Grid>
        <Grid item xs={12}>
          <PriceLines className={classes.prices} />
        </Grid>

        {serviceType !== SERVICE_TYPE.PICKUP && (
          <Grid item xs={12}>
            <Tips />
          </Grid>
        )}

        <Grid item xs={12}>
          <PriceLineTotal />
        </Grid>

        <Grid item xs={12} className={classes.placeOrderButtonContainer}>
          <PlaceOrderButton className={classes.placeOrderButton} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ShoppingCart;
